export var SDK_NAME = 'sentry.javascript.browser';
export var SDK_VERSION = '5.15.5';
//# sourceMappingURL=version.js.map


//////////////////
// WEBPACK FOOTER
// /usr/src/app/frontend/node_modules/@sentry/browser/esm/version.js
// module id = 150
// module chunks = 11